var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.34a6.66 6.66 0 100 13.32A6.66 6.66 0 008 1.34zm0 10A.84.84 0 118 13a.84.84 0 010-1.67zm0-8.08c.52 0 .78.26.78.78v5.78c0 .51-.26.77-.78.77s-.78-.26-.78-.77V4.04c0-.52.26-.78.78-.78z", "fill-rule": "nonzero" } }] }, name: "exclamation-circle", theme: "outlined" };
export {
  a as default
};
